import {
  NgModule,
  inject,
  PLATFORM_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TenantService } from './core/services/tenant.service';
import { isPlatformBrowser } from '@angular/common';
import { SharedModule } from './shared/shared.module';
import { UserModule } from './features/user/user.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  AUTH_CONFIG,
  CartComponent,
  LOGIN_SUCCESS_REDIRECT,
  AuthService,
  LoadingInterceptor,
} from '@adminprodigydesign/axis';
import { FeaturesModule } from './features/features.module';
import { RouterModule } from '@angular/router';
import { env } from 'process';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthExpiryInterceptor } from './core/interceptors/auth-expiry.interceptor';

export function initTenantConfig() {
  const tenantService = inject(TenantService);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformBrowser(platformId)) {
    return tenantService.loadTenantConfig();
  } else {
    return Promise.resolve();
  }
}

export function initAuthSession() {
  const authService = inject(AuthService);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformBrowser(platformId)) {
    return authService.initSession();
  } else {
    return Promise.resolve(true);
  }
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    UserModule,
    FontAwesomeModule,
    CartComponent,
    FeaturesModule,
    BrowserAnimationsModule,
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideClientHydration(withEventReplay()),
    provideHttpClient(
      // withInterceptors([LoadingInterceptor]),
      withInterceptorsFromDi(),
    ),
    provideAppInitializer(initTenantConfig),
    provideAppInitializer(initAuthSession),
    { provide: LOGIN_SUCCESS_REDIRECT, useValue: '/account' },
    {
      provide: AUTH_CONFIG,
      useValue: {
        apiUrl: environment.apiBaseUrl,
      },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiryInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
